var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.46 6.16016C21.69 6.51016 20.86 6.74016 20 6.85016C20.88 6.32016 21.56 5.48016 21.88 4.47016C21.05 4.97016 20.13 5.32016 19.16 5.52016C18.37 4.66016 17.26 4.16016 16 4.16016C13.65 4.16016 11.73 6.08016 11.73 8.45016C11.73 8.79016 11.77 9.12016 11.84 9.43016C8.28004 9.25016 5.11004 7.54016 3.00004 4.95016C2.63004 5.58016 2.42004 6.32016 2.42004 7.10016C2.42004 8.59016 3.17004 9.91016 4.33004 10.6602C3.62004 10.6602 2.96004 10.4602 2.38004 10.1602V10.1902C2.38004 12.2702 3.86004 14.0102 5.82004 14.4002C5.19077 14.5724 4.53013 14.5963 3.89004 14.4702C4.16165 15.3226 4.69358 16.0686 5.41106 16.6031C6.12854 17.1376 6.99549 17.4338 7.89004 17.4502C6.37367 18.6506 4.49404 19.2995 2.56004 19.2902C2.22004 19.2902 1.88004 19.2702 1.54004 19.2302C3.44004 20.4502 5.70004 21.1602 8.12004 21.1602C16 21.1602 20.33 14.6202 20.33 8.95016C20.33 8.76016 20.33 8.58016 20.32 8.39016C21.16 7.79016 21.88 7.03016 22.46 6.16016Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTwitter);
export default __webpack_public_path__ + "static/media/footerTwitter.03d47a2360de0edab7cb2f52f55cb719.svg";
export { ForwardRef as ReactComponent };